import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#794D32",
    "col2n": "#AC8268"
}
function ShiMot122({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M26.3 6.3q-2.45-.65-5.2-.65-2.85 0-5.4.7-.4-2.3-2.2-4.05Q11.2 0 7.95 0q-3.3 0-5.6 2.3Q0 4.6 0 7.9q0 3.25 2.35 5.6.9.9 1.95 1.45-1.65 2.55-2.4 5.45-.6 2.4-.6 5.1 0 8.2 5.8 14l.4.4q5.7 5.4 13.6 5.4 8.25 0 14-5.8 5.85-5.8 5.85-14 0-5.95-3.05-10.65.9-.55 1.75-1.35 2.3-2.35 2.3-5.6 0-3.3-2.3-5.6Q37.3 0 34.05 0q-3.3 0-5.6 2.3-1.7 1.7-2.15 4z"
                    id="ShiMot122__Symbol_105_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M7.9 30.9q0 3.3 2.75 5.6 2.8 2.35 6.7 2.35 3.9 0 6.65-2.35 2.8-2.3 2.8-5.6T24 25.25q-2.75-2.35-6.65-2.35-3.9 0-6.7 2.35Q7.9 27.6 7.9 30.9M7.05 1.2Q5.85 0 4.15 0t-2.9 1.2Q0 2.4 0 4.15q0 1.7 1.25 2.9.75.75 1.8 1.1.15-.2.3-.35 2.25-2.3 4.9-3.65 0-1.75-1.2-2.95m26.1 5.85q1.2-1.2 1.2-2.9 0-1.75-1.2-2.95-1.2-1.2-2.9-1.2t-2.9 1.2Q26.2 2.35 26.15 4q2.55 1.3 4.8 3.4l.4.4.25.25q.85-.3 1.55-1z"
                    id="ShiMot122__Symbol_107_0_Layer0_0_FILL"
                />
                <path
                    d="M198.2 297.85q-.213.013-.4.2-.686.746-1.15.95-.35.208-.8.2-.444.001-.75-.1 0 .012-.05 0-.17-.051-.65-.35v.05q-.91-.585-2.1-.65h-.05q-1.202.058-2.1.65l.05-.05q-.47.297-.7.35-.05.009-.1 0-.232.097-.7.1-.406.005-.8-.2-.44-.224-1-.95-.128-.17-.4-.2-.224-.03-.45.1-.17.178-.2.4-.03.273.1.45.79 1.023 1.45 1.3l-.05-.05q.656.345 1.35.35.64.003 1-.1.37-.047 1.1-.5.634-.397 1.45-.45.86.035 1.5.45h.05q.72.451 1 .5l-.05-.05q.444.149 1.1.15.75-.008 1.35-.35.586-.246 1.45-1.2.2-.18.2-.45-.013-.213-.2-.4-.18-.151-.45-.15m-7.8-4.35q0 .9.65 1.55t1.55.65q.95 0 1.6-.65.6-.65.6-1.55 0-.95-.6-1.55-.65-.65-1.6-.65-.9 0-1.55.65-.65.6-.65 1.55m-1.4-9.4q-.2-.7-.65-1.3-.7-.95-1.75-.95t-1.8.95q-.4.6-.6 1.3-.1.45-.1 1 0 1.35.7 2.25.75.95 1.8.95t1.75-.95q.75-.9.75-2.25 0-.55-.1-1m12.05 0q-.2-.7-.65-1.3-.7-.95-1.75-.95t-1.8.95q-.4.6-.6 1.3-.1.45-.1 1 0 1.35.7 2.25.75.95 1.8.95t1.75-.95q.75-.9.75-2.25 0-.55-.1-1z"
                    id="ShiMot122__Layer1_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ShiMot122__Symbol_105_0_Layer0_0_FILL"
                transform="translate(171.45 262.55)"
                id="ShiMot122__col1n"
            />
            <use
                xlinkHref="#ShiMot122__Symbol_107_0_Layer0_0_FILL"
                transform="translate(175.2 266.15)"
                id="ShiMot122__col2n"
            />
            <use xlinkHref="#ShiMot122__Layer1_0_FILL" />
        </g></g>
    )
}
export default ShiMot122
